// import React from "react";
// import { Grid } from "@mui/material";

// const TwoFieldRow = ({ children }) => {
//   const filteredChildren = React.Children.toArray(children).filter(Boolean);
//   return (
//     <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
//       {filteredChildren.map((child, idx) => (
//         <Grid item xs={12} md={6} key={child.key || idx}>
//           {React.cloneElement(child, { fullWidth: true })}
//         </Grid>
//       ))}
//     </Grid>
//   );
// };

// export default TwoFieldRow;


import React from "react";
import { Grid } from "@mui/material";

const TwoFieldRow = ({ children }) => {
  const filteredChildren = React.Children.toArray(children).filter(Boolean);
  return (
    // <Grid container spacing={2.5} alignItems="flex-start" sx={{ mb: 0.5 }}>
    <Grid container spacing={2} alignItems="center"  alignItems="flex-start"  sx={{ mb: 2 }}>
      {filteredChildren.map((child, idx) => (
        <Grid item xs={12} md={6} key={child.key || idx}>
          {React.cloneElement(child, { fullWidth: true })}
        </Grid>
      ))}
    </Grid>
  );
};

export default TwoFieldRow;